/* [BD feat] PDP Custom Layout */
if (!customElements.get('bd-variant-picker')) {
  class BDVariantPicker extends HTMLElement {
    connectedCallback() {
      this.optionIndex = parseInt(this.dataset.optionIndex) || 0;
      this.sectionId = this.dataset.section;
      this.selectedDisplay = this.querySelector('[data-selected-value]');

      this.querySelectorAll('[data-dropdown-toggle]').forEach(el => {
        el.addEventListener('click', (e) => {
          e.stopPropagation();
          this.classList.toggle('bd-pdp__variant-picker--open');
        });
      });

      this.querySelectorAll('.bd-pdp__variant-picker-item').forEach(item => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          this.onItemSelect(item.dataset.value, item);
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.classList.remove('bd-pdp__variant-picker--open');
        }
      });

      // Keep selected value in sync when theme updates variant (e.g. URL param)
      const variantSelects = document.getElementById(`variant-selects-${this.sectionId}`);
      if (variantSelects) {
        variantSelects.addEventListener('change', () => {
          const select = variantSelects.querySelectorAll('select')[this.optionIndex];
          if (select && this.selectedDisplay) {
            this.selectedDisplay.textContent = select.value;
            this.querySelectorAll('.bd-pdp__variant-picker-item').forEach(item => {
              item.classList.toggle('is-selected', item.dataset.value === select.value);
            });
          }
        });
      }
    }

    onItemSelect(value, item) {
      if (this.selectedDisplay) this.selectedDisplay.textContent = value;

      this.querySelectorAll('.bd-pdp__variant-picker-item').forEach(i => i.classList.remove('is-selected'));
      item.classList.add('is-selected');
      this.classList.remove('bd-pdp__variant-picker--open');

      // Drive the native variant-selects select for this option index
      const variantSelects = document.getElementById(`variant-selects-${this.sectionId}`);
      if (!variantSelects) return;

      const select = variantSelects.querySelectorAll('select')[this.optionIndex];
      if (select) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  customElements.define('bd-variant-picker', BDVariantPicker);
}
/* [BD feat] PDP Custom Layout */
